module.exports = __webpack_public_path__ + "static/media/leverageBarChart.849ccfe2.png";